export default "__VITE_ASSET__DANyRP3W__"